<template>
  <div class="Main_container">
    <div class="screen_recording_preview_card">
      <div class="corner_webcam">Webcam preview</div>
      <h1 class="preview_t">You can start your playtest and comeback once you are finished</h1>
    </div>
    <div class="instructions_card">
      <div class="Instructions_list">
        <p class="instructions_title">Player instructions</p>
        <div class="instructions_1">Instruction 1</div>
        <div class="instructions_2">Instruction 2</div>
        <div class="instructions_3">Instruction 3</div>
        <div class="instructions_4">Instruction 4</div>
        <div class="instructions_5">Instruction 5</div>
        <div class="instructions_6">Instruction 6</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PlaytestScreenRecording"
  }
</script>

<style>
  .Main_container {
    background: white;
    padding: 50px;
    margin: 0px 0px 50px;
    max-width: 100%;
    min-width: 50%;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: normal;
    border-radius: 14px;
  }

  .screen_recording_preview_card {
    background-color: #4F4F4F;
    max-width: 100%;
    width: 100%;
    height: 100%;
    border-radius: 14px 0px 0px 14px;
  }
  .corner_webcam {
    background-color: #E7E7E7;
    max-width: 200%;
    width:30%;
    padding: 100px 25px;
    text-align:center;
  }
  .preview_t{
    max-width:100%;
    width:100%;
    padding: 150px 200px;
    text-align:center;
    color: white;
  }
  .instructions_card {
    background-color: #5C636A;
    max-width: 100%;
    max-height: 100%;
    width: 50%;
    border-radius: 0px 14px 14px 0px;
  }
  .instructions_title {
    color: white;
    margin: 10px;
    padding: 4px 4px;
    font-size: 22px;
  }
  .instructions_list{
    display: flex;
    flex-direction: column;
  }
  .instructions_1, .instructions_2, .instructions_3, .instructions_4, .instructions_5, .instructions_6 {
    background-color: #E7E7E7;
    margin: 10px;
    padding: 10px 4px 10px;
    min-width: 40%;
    border-radius: 8px;
    border: hidden;
    text-align: left;
    font-size: 16px;
  }  
</style>



// WEBPACK FOOTER //
// src/components/playtest/Playtest-ScreenRecording.vue